import { render, staticRenderFns } from "./work.participants.page.vue?vue&type=template&id=f445fdc8&"
import script from "./work.participants.page.vue?vue&type=script&lang=js&"
export * from "./work.participants.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports